import React from 'react';

import { ArticleEditorFooterWrapper } from 'components/ArticleEditorFooter/ArticleEditorFooterWrapper';
import { ArticleEditorFooterSubmitDraftButton } from 'components/ArticleEditorFooter/ArticleEditorFooterSubmitDraftButton';
import { ArticleEditorFooterNotifyCheckbox } from 'components/ArticleEditorFooter/ArticleEditorFooterNotifyCheckbox';
import { ArticleEditorFooterCancelButton } from 'components/ArticleEditorFooter/ArticleEditorFooterCancelButton';
import { ArticleEditorFooterSubmitButton } from 'components/ArticleEditorFooter/ArticleEditorFooterSubmitButton';
import { testId } from 'utils/testId';

type TProps = {
  hasSubmitDraftButton: boolean;
  hasSubmitDraftButtonPreloader: boolean;
  hasNotifyCheckbox: boolean;
  hasSubmitButtonPreloader: boolean;
  isSubmitButtonDisabled: boolean;
  isNotifyCheckboxChecked: boolean;
  handleSubmit(): void;
  handleSubmitDraft(): void;
  handleCancel(): void;
  handleNotifyCheckboxChange(): void;
};

export const NewsPreviewFooterView = (props: TProps) => {
  const {
    hasSubmitDraftButton,
    hasSubmitDraftButtonPreloader,
    hasNotifyCheckbox,
    hasSubmitButtonPreloader,
    isSubmitButtonDisabled,
    isNotifyCheckboxChecked,
    handleSubmit,
    handleSubmitDraft,
    handleCancel,
    handleNotifyCheckboxChange
  } = props;

  return (
    <ArticleEditorFooterWrapper>
      {hasSubmitDraftButton && (
        <ArticleEditorFooterSubmitDraftButton
          hasPreloader={hasSubmitDraftButtonPreloader}
          onClick={handleSubmitDraft}
        />
      )}
      {hasNotifyCheckbox && (
        <ArticleEditorFooterNotifyCheckbox
          isChecked={isNotifyCheckboxChecked}
          onChange={handleNotifyCheckboxChange}
        />
      )}
      <ArticleEditorFooterCancelButton
        testId={testId.NEWS_ARTICLE_EDITOR_CANCEL_BUTTON}
        onClick={handleCancel}
      />
      <ArticleEditorFooterSubmitButton
        onClick={handleSubmit}
        isDisabled={isSubmitButtonDisabled}
        hasPreloader={hasSubmitButtonPreloader}
      />
    </ArticleEditorFooterWrapper>
  );
};
